import * as React from 'react';
import { StyledInformationalPage } from '../../../../common/static.styles';
import { HeadTitle } from '../../../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../../../layout/default/DefaultLayout';

// tslint:disable:max-line-length
const seo = {
  description:
    'WARNER BROS. is a fully integrated entertainment company and a global leader in the creation, production, distribution, licensing and marketing of all forms of entertainment.',
};

// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='en-US' seo={seo}>
    <HeadTitle title='Company Overview' />
    <StyledInformationalPage>
      <div className='content'>
        <div>
          <h1>Company Overview</h1>
        </div>
        <div className='info-page-logo'>
          <img alt='Warner Bros.' className='img-responsive' src={'/assets/images/blue-wb-shield-500x480.png'} />
        </div>
        <div>
          <p>
            <strong>WARNER BROS.</strong> is a fully integrated entertainment company and a global leader in the
            creation, production, distribution, licensing and marketing of all forms of entertainment. A Warner Bros.
            Discovery company, the Studio is home to one of the most successful collections of brands in the world and
            stands at the forefront of every aspect of the entertainment industry, from feature film, television,
            digital and home entertainment production and worldwide distribution to DVD and Blu-ray, animation, comic
            books, videogames, and product and brand licensing. The company’s vast library, one of the most prestigious
            and valuable in the world, consists of more than 145,000 hours of programming, including 12,500 feature
            films and 2,400 television programs comprised of more than 150,000 individual episodes.
          </p>
          <p>
            Warner Bros. began when the brothers Warner (Albert, Sam, Harry and Jack L.) incorporated their fledgling
            movie company on April 4, 1923. In 1927, the release of the world’s first “talkie,” (synchronized-sound
            feature film), “The Jazz Singer,” set a character and tone of creativity, courage, innovation and influence
            that would become synonymous with the name Warner Bros. And--as Al Jolson foretold in this milestone
            movie--“you ain’t heard nothin’ yet!”
          </p>

          <p>
            Since those early days, Warner Bros. Studios has amassed an impressive legacy based on world-class quality
            entertainment and technological foresight and created a diversified entertainment company with an
            unparalleled depth and breadth. Its century of continued success has been built on a foundation of long-term
            creative relationships with many of the world’s leading talent, and an unwavering dedication to excellence.
          </p>
          <p>
            <strong>Warner Bros. Pictures Group</strong> produces and distributes a wide-ranging, diverse slate of films
            each year. In 2023, Warner Bros. Pictures Group will continue to produce the industry’s broadest roster of
            films, featuring the Studio’s DC Super Hero titles, New Line Cinema’s horror titles, thoughtful dramas and
            smart comedies.
          </p>
          <p>
            <strong>New Line Cinema</strong>, part of Warner Bros. Entertainment since 2008, coordinates its
            development, production, marketing, distribution and business affairs activities with Warner Bros. Pictures
            Group to maximize film performance and operating efficiencies.
          </p>
          <p>
            <strong>DC Studios</strong> is responsible for overseeing the overall creative direction of the DC Universe
            across film, TV, and animation under a single banner. Spearheading the development and execution of a
            long-term plan for the many properties licensed from DC Comics, DC Studios is focused on continuing the
            tradition of high-quality storytelling for the DCU across audio-visual media, while building a sustainable
            growth business out of the iconic franchise. DC Studios also works collaboratively across every division of
            Warner Bros. Discovery, including film, TV, games, consumer products, live events, networks and more to help
            realize the vast potential of the DCU.
          </p>
          <p>
            <strong>The Warner Bros. Television Group</strong> oversees and grows the entire portfolio of Warner Bros.’
            television production businesses, including scripted and unscripted programming, and animation. WBTVG
            production divisions include Warner Bros. Television, one of the industry’s leading suppliers of live-action
            scripted programming;
            <strong> Warner Bros. Unscripted Television,</strong> which produces award-winning unscripted series through
            the <strong> Warner Horizon, Telepictures,</strong> and <strong>Shed Media</strong> production labels; and
            three animation studios: <strong>Warner Bros. Animation, Cartoon Network Studios,</strong> and{' '}
            <strong>Hanna-Barbera Studios Europe.</strong> As of March 2023, these divisions are producing more than 100
            live-action scripted dramas, comedies, limited series, unscripted programs, and animated series, movies, and
            specials for Warner Bros. Discovery’s HBO Max, external streaming platforms, cable, traditional broadcast
            networks, and the first-run syndication marketplace in the U.S.
          </p>
          <p>
            <strong>Warner Bros. Discovery Home Entertainment</strong> distributes the movies, television, animation,
            and digital content produced by Warner Bros. Discovery to the homes and screens of millions through physical
            Blu-ray Disc and DVD retail sales, and digital transactions on major streaming, video-on-demand cable,
            satellite, digital, and mobile channels.  WBDHE is part of Warner Bros. Discovery Content Sales, one of the
            world’s largest distributors of entertainment programming.
          </p>
          <p>
            <strong>Warner Bros. Discovery Global Brands and Experiences</strong> is the global division that drives
            opportunities for consumers to engage with WBD’s leading entertainment brands and franchises. Through its
            strategic franchise development group and global commercial businesses, GBE creates lasting connections to
            WBD’s iconic characters, talent, and storytelling. GBE operates{' '}
            <strong>WBD’s Global Consumer Products, Global Themed Entertainment,</strong> and world-renowned comic and
            publishing powerhouse <strong>DC.</strong>
          </p>
          <p>
            <strong>Warner Bros. Games</strong> is a premier worldwide publisher, developer, licensor and distributor of
            entertainment content for the interactive space across all platforms, including console, handheld, mobile
            and PC-based gaming for both internal and third-party game titles.
          </p>
          <p>
            Warner Bros. Entertainment is headquartered at the Warner Bros. Studios lot, 142 acres in Burbank,
            California, which is considered one of the foremost motion picture and television production and
            post-production facilities in the world and home to 36 soundstages (including one of the world’s tallest
            stages, which has an in-ground tank capable of holding more than two million gallons of water). In addition,{' '}
            <strong>Warner Bros. Worldwide Studio Operations</strong> is responsible for managing the company’s studio
            in the UK – Warner Bros. Studios Leavesden – a 160-acre production facility that has been the production
            site of many highly acclaimed Warner Bros. movies.
          </p>
          <p>
            Today, as the company celebrates its centennial throughout 2023, these businesses carry forth the mission
            started by the four Warner brothers – CELEBRATING EVERY STORY.
          </p>
        </div>
      </div>
    </StyledInformationalPage>
  </DefaultLayout>
);
